import React from 'react';
import PropTypes from 'prop-types';

import Progress from 'components/progress/circle';
import { USD } from 'helpers/formatters/number_formats';
import { brokerColors, outsideCommissionsColor } from 'helpers/charts/backoffice/voucher_palette';

export default function BrokerCommission({ commission, index, transactionSide }) {
  let dataSource;
  if (transactionSide) {
    dataSource = commission.transactionSideDetails.find(details => details.transactionSide === transactionSide);
  } else {
    dataSource = commission;
  }

  return (
    <div className="commission d-flex align-items-center">
      <Progress
        color={commission.outside ? outsideCommissionsColor : brokerColors[index]}
        percent={dataSource.grossPercent}
      />

      <div className="ml-4">
        <h4 className="mt-0 mb-1">{USD.format(dataSource.grossAmount)}</h4>
        <div className="text-muted">Gross Commission</div>
      </div>
    </div>
  );
}

BrokerCommission.propTypes = {
  commission: PropTypes.shape({
    grossAmount: PropTypes.number.isRequired,
    grossPercent: PropTypes.number.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  transactionSide: PropTypes.string,
};
